import { prop } from 'ramda';

const getData = prop('data');

export default getData;
